import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchApplicationFormTemplate } from '../../store/investor/investorApiHelper';
import { closeApplicationForm, setApplicationFormData } from '../../store/investor/action';
import { TEXT_EDITOR_TYPES } from '../../store/investor/constants';
import {
    AICA_APPLICATION_FORM_PREVIEW,
    AICA_APPLICATION_FORM_RESTORE_VERSION,
    AICA_APPLICATION_FORM_SAVE,
} from '../../utils/constants/mixpanelEvents/investorEvents';
import DocumentContainer from '../DocumentEditor/DocumentContainer';

function ApplicationForm() {
    const dispatch = useAppDispatch();
    const applicationFormData = useAppSelector((state) => state.investor.applicationForm);

    if (!applicationFormData?.open) {
        return null;
    }

    return (
        <DocumentContainer
            orgId={applicationFormData.orgId ?? ''}
            source={applicationFormData.source ?? ''}
            loading={!!applicationFormData.loading}
            companyName={applicationFormData.companyName ?? ''}
            onUnmount={() => dispatch(closeApplicationForm())}
            setLoading={(loading) => dispatch(setApplicationFormData({ loading }))}
            onSaveComplete={() => dispatch(closeApplicationForm())}
            fetchTemplate={fetchApplicationFormTemplate}
            docType="APPLICATION_FORM"
            regenTitle="Application Form"
            editorType={TEXT_EDITOR_TYPES.APPLICATION_FORM}
            documentType="applicationForm"
            fileNamePrefix="ApplicationForm"
            commentContainerId="application-form-comment-container"
            mixpanelPreviewEvent={AICA_APPLICATION_FORM_PREVIEW}
            mixpanelSaveEvent={AICA_APPLICATION_FORM_SAVE}
            mixpanelRestoreVersionEvent={AICA_APPLICATION_FORM_RESTORE_VERSION}
            enableHistory={true}
        />
    );
}

export default ApplicationForm;
